export const ALT_MARKETS = ["ch"];
